<template>
  <div class="action-list">
    <div
      v-if="!local.length"
      class="text-muted small"
    >
      Nenhuma ação ainda.
    </div>

    <b-card
      v-for="(a, idx) in local"
      :key="'act-'+idx"
      class="mb-3 action-card"
      body-class="p-2"
    >
      <!-- Cabeçalho -->
      <div class="d-flex align-items-start mb-1">
        <div class="flex-grow-1 mr-2">
          <b-form-group
            label="Ação"
            label-class="mb-0 font-weight-600"
          >
            <b-form-select
              v-model="a.action"
              :options="actionOptions"
              @change="onActionChange(idx)"
            />
          </b-form-group>
        </div>
        <div class="pl-2 d-flex align-items-start">
          <b-button
            size="sm"
            variant="outline-danger"
            title="Remover"
            @click="removeAction(idx)"
          >
            🗑️
          </b-button>
        </div>
      </div>

      <!-- ========================= send_text ========================= -->
      <div v-if="a.action==='send_text'">
        <!-- Collapsy: Condições de envio -->
        <b-card
          no-body
          class="mb-2"
        >
          <b-card-header class="py-2 px-2 d-flex align-items-center justify-content-between">
            <div class="section-title mb-0">
              Condições de envio
            </div>
            <b-button
              v-b-toggle="`cond-${idx}`"
              size="sm"
              variant="light"
              class="toggle-collapse"
              :aria-controls="`cond-${idx}`"
              :title="condOpen[idx] ? 'Recolher' : 'Expandir'"
            >
              <i
                class="feather"
                :class="condOpen[idx] ? 'icon-chevron-up' : 'icon-chevron-down'"
              />
            </b-button>
          </b-card-header>

          <b-collapse
            :id="`cond-${idx}`"
            v-model="condOpen[idx]"
            accordion="act-conds"
          >
            <b-card-body class="p-2">
              <ul class="checklist">
                <li>
                  <b-form-checkbox
                    v-model="a.preview"
                    switch
                    @change="emitChange"
                  >
                    Ativar preview
                  </b-form-checkbox>
                  <div class="help">
                    Se houver URL no texto, tenta gerar cartão de preview.
                  </div>
                </li>

                <li>
                  <b-form-checkbox
                    switch
                    :checked="isFirstContactEnabled(a)"
                    @input="onToggleFirstContact(a, $event)"
                  >
                    Primeiro contato (enviar apenas na 1ª vez)
                  </b-form-checkbox>
                </li>

                <li>
                  <b-form-checkbox
                    switch
                    :checked="isDaysEnabled(a)"
                    @input="onToggleDays(a, $event)"
                  >
                    Restringir por dias da semana
                  </b-form-checkbox>

                  <div
                    v-if="isDaysEnabled(a)"
                    class="dow-wrap mt-1"
                  >
                    <b-form-checkbox
                      v-for="opt in weekOpts"
                      :key="'dow-'+opt.value"
                      :checked="a.conditional && a.conditional.days_of_weekProxy && a.conditional.days_of_weekProxy[opt.value]"
                      @change="val => setDaysProxyVal(a, opt.value, val)"
                    >
                      {{ opt.text }}
                    </b-form-checkbox>
                  </div>
                </li>

                <li>
                  <b-form-checkbox
                    switch
                    :checked="isDatesEnabled(a)"
                    @input="onToggleDates(a, $event)"
                  >
                    Restringir por datas específicas
                  </b-form-checkbox>

                  <div
                    v-if="isDatesEnabled(a)"
                    class="mt-1"
                  >
                    <b-form-tags
                      v-model="a.conditional.dates"
                      separator=","
                      remove-on-delete
                      placeholder="YYYY-MM-DD e Enter"
                      @input="emitChange"
                    />
                    <div class="help">
                      Se houver ao menos uma, envia somente nessas datas.
                    </div>
                  </div>
                </li>
              </ul>
            </b-card-body>
          </b-collapse>
        </b-card>

        <!-- Texto -->
        <b-form-group :label="isFirstContactEnabled(a) ? 'Texto (Primeiro contato)' : 'Texto'">
          <b-form-textarea
            v-if="!isFirstContactEnabled(a)"
            v-model="a.text"
            rows="3"
            max-rows="8"
            @input="emitChange"
          />
          <b-form-textarea
            v-else
            v-model="a.conditional.first_contact.first_time"
            rows="3"
            max-rows="8"
            @input="emitChange"
          />
        </b-form-group>

        <!-- Retorno -->
        <div
          v-if="isFirstContactEnabled(a)"
          class="mt-2"
        >
          <b-form-checkbox
            switch
            :checked="hasReturning(a)"
            class="mb-1"
            @input="onToggleReturning(a, $event)"
          >
            Adicionar texto para retornos
          </b-form-checkbox>

          <b-form-group
            v-if="hasReturning(a)"
            label="Texto (Retorno)"
          >
            <b-form-textarea
              v-model="a.conditional.first_contact.returning"
              rows="3"
              max-rows="8"
              @input="emitChange"
            />
          </b-form-group>
        </div>
      </div>
      <!-- ======================= /send_text ========================= -->

      <!-- ====================== send_buttons ======================= -->
      <div v-else-if="a.action==='send_buttons'">
        <div class="stacked">
          <b-form-group label="Header (opcional)">
            <b-form-input
              v-model="a.header"
              @input="emitChange"
            />
          </b-form-group>

          <b-form-group label="Body">
            <b-form-textarea
              v-model="a.body"
              rows="3"
              max-rows="8"
              @input="emitChange"
            />
          </b-form-group>

          <b-form-group label="Footer (opcional)">
            <b-form-input
              v-model="a.footer"
              @input="emitChange"
            />
          </b-form-group>
        </div>

        <div class="d-flex justify-content-between align-items-center mt-2 mb-1">
          <div class="small text-muted">
            Botões (máx. 10)
          </div>
          <b-button
            size="sm"
            variant="outline-primary"
            @click="addButton(idx)"
          >
            + botão
          </b-button>
        </div>

        <draggable
          v-model="a.buttons"
          :options="{ handle: '.drag', animation: 150 }"
          @end="emitChange"
        >
          <transition-group
            type="transition"
            name="flip-list"
          >
            <b-card
              v-for="(btn, bIdx) in (a.buttons||[])"
              :key="'btn-'+bIdx"
              class="mb-2"
              body-class="p-2"
            >
              <div class="d-flex">
                <span
                  class="drag mr-2"
                  style="cursor:grab"
                  title="Arrastar"
                >↕</span>
                <div class="flex-grow-1 stacked">
                  <b-form-group label="Título do botão">
                    <b-form-input
                      v-model="btn.title"
                      :maxlength="20"
                      placeholder="Ex.: Status do pedido"
                      @input="onButtonTitleChange(a, btn)"
                    />
                    <div class="char-hint">
                      {{ (btn.title || '').length }}/20
                    </div>
                  </b-form-group>

                  <b-form-group label="ID">
                    <b-form-input
                      :value="btn.id"
                      disabled
                    />
                  </b-form-group>

                  <b-form-group label="Ação ao clicar">
                    <b-form-select
                      v-model="btn.click_action"
                      :options="clickActionOpts"
                      @change="onButtonActionChanged(btn)"
                    />
                  </b-form-group>

                  <b-form-group
                    v-if="btn.click_action==='goto'"
                    label="Destino (estado)"
                  >
                    <b-form-select
                      v-model="btn.goto_state"
                      :options="stateNames"
                      @change="emitRuleForButton(btn)"
                    />
                    <div
                      v-if="btn.goto_state"
                      class="small text-muted mt-1"
                    >
                      ir para → <span class="font-weight-600">{{ btn.goto_state }}</span>
                    </div>
                  </b-form-group>

                  <div
                    v-else-if="btn.click_action==='set_mode'"
                    class="small text-muted"
                  >
                    ir para a central
                  </div>
                </div>

                <div class="pl-2 d-flex align-items-start">
                  <b-button
                    size="sm"
                    variant="outline-danger"
                    title="Remover botão"
                    @click="removeButton(a, bIdx)"
                  >
                    🗑️
                  </b-button>
                </div>
              </div>
            </b-card>
          </transition-group>
        </draggable>
      </div>
      <!-- ===================== /send_buttons ======================= -->

      <!-- ======================== send_list ======================== -->
      <div v-else-if="a.action==='send_list'">
        <div class="stacked">
          <b-form-group label="Header (opcional)">
            <b-form-input
              v-model="a.header"
              @input="emitChange"
            />
          </b-form-group>

          <b-form-group label="Body">
            <b-form-textarea
              v-model="a.body"
              rows="3"
              max-rows="8"
              @input="emitChange"
            />
          </b-form-group>

          <b-form-group label="Texto do botão (abrir lista)">
            <b-form-input
              v-model="a.button_text"
              placeholder="Ex.: Ver opções"
              @input="emitChange"
            />
          </b-form-group>

          <b-form-group label="Título da seção (opcional)">
            <b-form-input
              v-model="a.sections[0].title"
              @input="emitChange"
            />
          </b-form-group>
        </div>

        <div class="d-flex justify-content-between align-items-center mt-2 mb-1">
          <div class="small text-muted">
            Opções
          </div>
          <b-button
            size="sm"
            variant="outline-primary"
            @click="addRow(idx)"
          >
            + opção
          </b-button>
        </div>

        <draggable
          v-model="a.sections[0].rows"
          :options="{ handle: '.drag', animation: 150 }"
          @end="emitChange"
        >
          <transition-group
            type="transition"
            name="flip-list"
          >
            <b-card
              v-for="(row, rIdx) in a.sections[0].rows"
              :key="'row-'+rIdx"
              class="mb-2"
              body-class="p-2"
            >
              <div class="d-flex">
                <span
                  class="drag mr-2"
                  style="cursor:grab"
                  title="Arrastar"
                >↕</span>
                <div class="flex-grow-1 stacked">
                  <b-form-group label="Título da opção">
                    <b-form-input
                      v-model="row.title"
                      :maxlength="24"
                      placeholder="Ex.: Nota fiscal"
                      @input="onRowTitleChange(a, row)"
                    />
                    <div class="char-hint">
                      {{ (row.title || '').length }}/24
                    </div>
                  </b-form-group>

                  <b-form-group label="ID">
                    <b-form-input
                      :value="row.id"
                      disabled
                    />
                  </b-form-group>

                  <b-form-group label="Ação ao clicar">
                    <b-form-select
                      v-model="row.click_action"
                      :options="clickActionOpts"
                      @change="onRowActionChanged(row)"
                    />
                  </b-form-group>

                  <b-form-group
                    v-if="row.click_action==='goto'"
                    label="Destino (estado)"
                  >
                    <b-form-select
                      v-model="row.goto_state"
                      :options="stateNames"
                      @change="emitRuleForRow(row)"
                    />
                    <div
                      v-if="row.goto_state"
                      class="small text-muted mt-1"
                    >
                      ir para → <span class="font-weight-600">{{ row.goto_state }}</span>
                    </div>
                  </b-form-group>

                  <div
                    v-else-if="row.click_action==='set_mode'"
                    class="small text-muted"
                  >
                    ir para a central
                  </div>
                </div>

                <div class="pl-2 d-flex align-items-start">
                  <b-button
                    size="sm"
                    variant="outline-danger"
                    title="Remover opção"
                    @click="removeRow(a, rIdx)"
                  >
                    🗑️
                  </b-button>
                </div>
              </div>
            </b-card>
          </transition-group>
        </draggable>
      </div>
      <!-- ======================= /send_list ======================== -->

      <!-- ===================== platform_lookup ===================== -->
      <div v-else-if="a.action==='platform_lookup'">
        <b-alert
          show
          variant="light"
          class="small"
        >
          Consulta na plataforma. <br>
          <strong>Observação:</strong> para <code>status_pedido</code>, configure as mensagens por status.
        </b-alert>

        <b-form-group label="Operação">
          <b-form-select
            v-model="a.op"
            :options="platformOps"
            @change="onPlatformOpChange(a)"
          />
        </b-form-group>

        <!-- status_pedido -->
        <div v-if="a.op==='status_pedido'">
          <b-card
            class="mb-2"
            body-class="p-2"
          >
            <div class="section-title mb-2">
              Mensagens por status
            </div>

            <div class="stacked">
              <b-form-group
                v-if="a.messages && a.messages.aguardando_pagamento && a.messages.aguardando_pagamento.length"
                label="Aguardando pagamento"
              >
                <b-form-textarea
                  v-model="a.messages.aguardando_pagamento[0].text"
                  rows="3"
                  max-rows="8"
                  @input="emitChange"
                />
              </b-form-group>

              <b-form-group
                v-if="a.messages && a.messages.aprovado && a.messages.aprovado.length"
                label="Aprovado"
              >
                <b-form-textarea
                  v-model="a.messages.aprovado[0].text"
                  rows="3"
                  max-rows="8"
                  @input="emitChange"
                />
              </b-form-group>

              <b-form-group
                v-if="a.messages && a.messages.cancelado && a.messages.cancelado.length"
                label="Cancelado"
              >
                <b-form-textarea
                  v-model="a.messages.cancelado[0].text"
                  rows="3"
                  max-rows="8"
                  @input="emitChange"
                />
              </b-form-group>

              <b-form-group
                v-if="a.messages && a.messages.analise_pagamento && a.messages.analise_pagamento.length"
                label="Análise de pagamento"
              >
                <b-form-textarea
                  v-model="a.messages.analise_pagamento[0].text"
                  rows="3"
                  max-rows="8"
                  @input="emitChange"
                />
              </b-form-group>

              <b-form-group
                v-if="a.messages && a.messages.em_transporte && a.messages.em_transporte.length"
                label="Em transporte"
              >
                <b-form-textarea
                  v-model="a.messages.em_transporte[0].text"
                  rows="3"
                  max-rows="8"
                  @input="emitChange"
                />
              </b-form-group>

              <b-form-group
                v-if="a.messages && a.messages.entregue && a.messages.entregue.length"
                label="Entregue"
              >
                <b-form-textarea
                  v-model="a.messages.entregue[0].text"
                  rows="3"
                  max-rows="8"
                  @input="emitChange"
                />
              </b-form-group>
            </div>
          </b-card>
        </div>

        <!-- link_transporte / nota_fiscal -->
        <div v-else-if="a.op==='link_transporte' || a.op==='nota_fiscal'">
          <b-card
            class="mb-2"
            body-class="p-2"
          >
            <div class="section-title mb-2">
              Mensagens de resultado
            </div>

            <div class="stacked">
              <b-form-group
                v-if="a.messages && a.messages.found && a.messages.found.length"
                label="Encontrado (found)"
              >
                <b-form-textarea
                  v-model="a.messages.found[0].text"
                  rows="3"
                  max-rows="8"
                  @input="emitChange"
                />
              </b-form-group>

              <b-form-group
                v-if="a.messages && a.messages.not_found && a.messages.not_found.length"
                label="Não encontrado (not_found)"
              >
                <b-form-textarea
                  v-model="a.messages.not_found[0].text"
                  rows="3"
                  max-rows="8"
                  @input="emitChange"
                />
              </b-form-group>
            </div>
          </b-card>
        </div>
      </div>
      <!-- =================== /platform_lookup ===================== -->

      <!-- ==================== validate_customer ==================== -->
      <div v-else-if="a.action==='validate_customer'">
        <b-alert
          show
          variant="info"
          class="small mb-0"
        >
          Valida o cliente na plataforma. O fluxo só continua se houver CPF salvo em <code>vars.cpf</code>.<br>
          Caso contrário, o bot pedirá <strong>CPF ou nº do pedido</strong>, validará e retomará o fluxo automaticamente.
        </b-alert>
      </div>
      <!-- ================== /validate_customer ===================== -->

      <!-- ==================== ask_var / goto / set_mode / set_tags / end ====== -->
      <div v-else-if="a.action==='ask_var'">
        <div class="stacked">
          <b-form-group label="Variável">
            <b-form-input
              v-model="a.var"
              placeholder="Ex.: order_id"
              @input="emitChange"
            />
          </b-form-group>
          <b-form-group label="Pergunta">
            <b-form-textarea
              v-model="a.prompt"
              rows="3"
              max-rows="8"
              @input="emitChange"
            />
          </b-form-group>
        </div>
      </div>

      <div v-else-if="a.action==='goto'">
        <b-form-group label="Ir para (estado)">
          <b-form-select
            v-model="a.state"
            :options="stateNames"
            @change="emitChange"
          />
          <div
            v-if="a.state"
            class="small text-muted mt-1"
          >
            ir para → <span class="font-weight-600">{{ a.state }}</span>
          </div>
        </b-form-group>
      </div>

      <div v-else-if="a.action==='set_mode'">
        <b-alert
          show
          variant="light"
          class="small"
        >
          ir para a central
        </b-alert>
        <div class="stacked">
          <b-form-select
            v-model="a.mode"
            :options="[{text:'central', value:'central'}]"
            @change="emitChange"
          />

          <b-form-group
            class="mt-2"
            label="Atribuir para atendentes (um ou mais)"
          >
            <b-form-select
              v-model="a.assign_random_agent_ids"
              multiple
              :options="agentOptions"
              :disabled="loadingAgents || !botUuid"
              @change="emitChange"
            />
            <small
              v-if="!botUuid"
              class="text-muted d-block mt-1"
            >
              Informe o UUID do bot para listar os atendentes.
            </small>
            <small
              v-else-if="loadingAgents"
              class="text-muted d-block mt-1"
            >
              Carregando atendentes...
            </small>
            <small
              v-else-if="agentsError"
              class="text-danger d-block mt-1"
            >
              {{ agentsError }}
            </small>
          </b-form-group>

          <div
            v-if="selectedAgents(a).length"
            class="mt-2"
          >
            <div class="small text-muted mb-1">
              Selecionados:
            </div>
            <div>
              <b-badge
                v-for="ag in selectedAgents(a)"
                :key="'sel-'+ag.value"
                variant="primary"
                class="mr-2 mb-2"
              >
                {{ ag.text }}
                <b-button
                  size="xs"
                  variant="link"
                  class="p-0 ml-1 text-white"
                  aria-label="Remover"
                  @click="removeSelectedAgent(a, ag.value)"
                >×</b-button>
              </b-badge>
            </div>
          </div>
        </div>
      </div>

      <div v-else-if="a.action==='set_tags'">
        <div class="stacked">
          <b-form-group label="Tags da conversa">
            <b-form-select
              v-model="a.tags"
              multiple
              :options="tagOptions"
              :disabled="loadingTags || !botUuid"
              @change="emitChange"
            />
            <small
              v-if="!botUuid"
              class="text-muted d-block mt-1"
            >
              Informe o UUID do bot para listar as tags.
            </small>
            <small
              v-else-if="loadingTags"
              class="text-muted d-block mt-1"
            >
              Carregando tags...
            </small>
            <small
              v-else-if="tagsError"
              class="text-danger d-block mt-1"
            >
              {{ tagsError }}
            </small>
          </b-form-group>

          <div
            v-if="selectedTags(a).length"
            class="mt-2"
          >
            <div class="small text-muted mb-1">
              Selecionadas:
            </div>
            <div>
              <b-badge
                v-for="tg in selectedTags(a)"
                :key="'tag-'+tg.value"
                variant="secondary"
                class="mr-2 mb-2"
                :style="tg.color ? { backgroundColor: tg.color, borderColor: tg.color } : {}"
              >
                {{ tg.text }}
                <b-button
                  size="xs"
                  variant="link"
                  class="p-0 ml-1 text-white"
                  aria-label="Remover"
                  @click="removeSelectedTag(a, tg.value)"
                >×</b-button>
              </b-badge>
            </div>
          </div>
        </div>
      </div>

      <div v-else-if="a.action==='end'">
        <b-alert
          show
          variant="light"
          class="small mb-0"
        >
          Fim do fluxo atual.
        </b-alert>
      </div>
    </b-card>

    <b-button
      size="sm"
      variant="outline-secondary"
      @click="addAction"
    >
      + ação
    </b-button>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { buscaAtendentes, buscaTag } from '../../../functions/basics/chat'

export default {
  name: 'ActionList',
  components: { draggable },
  props: {
    actions: { type: Array, default: () => [] },
    stateNames: { type: Array, default: () => [] },
    autoRules: { type: Boolean, default: false },
    stateName: { type: String, default: '' },
    stateRules: { type: Array, default: () => [] },
    botUuid: { type: String, default: null },
  },
  data: () => ({
    local: [],
    _hydrating: false,

    // estado do collapsy por ação
    condOpen: {},

    // atendentes
    loadingAgents: false,
    agentsError: null,
    agentOptions: [],

    // tags
    loadingTags: false,
    tagsError: null,
    tagOptions: [],

    clickActionOpts: [
      { text: 'ir para', value: 'goto' },
      { text: 'set_mode (central)', value: 'set_mode' },
      { text: 'end', value: 'end' },
    ],
    actionOptions: [
      { text: 'Enviar texto', value: 'send_text' },
      { text: 'Enviar botões', value: 'send_buttons' },
      { text: 'Enviar lista', value: 'send_list' },
      { text: 'Perguntar variável', value: 'ask_var' },
      { text: 'Consultar plataforma', value: 'platform_lookup' },
      { text: 'Validar cliente na plataforma', value: 'validate_customer' },
      { text: 'Ir para (estado)', value: 'goto' },
      { text: 'Mudar modo', value: 'set_mode' },
      { text: 'Atribuir tags', value: 'set_tags' },
      { text: 'Encerrar', value: 'end' },
    ],
    platformOps: [
      { text: 'Status do pedido', value: 'status_pedido' },
      { text: 'Link de transporte (rastreio)', value: 'link_transporte' },
      { text: 'Nota fiscal', value: 'nota_fiscal' },
    ],
    weekOpts: [
      { text: 'Dom', value: 0 }, { text: 'Seg', value: 1 }, { text: 'Ter', value: 2 },
      { text: 'Qua', value: 3 }, { text: 'Qui', value: 4 }, { text: 'Sex', value: 5 },
      { text: 'Sáb', value: 6 },
    ],
  }),
  watch: {
    actions: { handler() { this.syncFromProps(); this.hydrateFromRules() }, deep: true },
    stateRules: { handler() { this.hydrateFromRules() }, deep: true },
    botUuid(nv, ov) { if (nv && nv !== ov) { this.loadAgents(); this.loadTags() } },
  },
  created() {
    this.syncFromProps()
    this.hydrateFromRules()
    this.maybeLoadAgents()
    this.maybeLoadTags()
  },
  methods: {
    /* ===== base ===== */
    syncFromProps() {
      this._hydrating = true
      try {
        const arr = Array.isArray(this.actions) ? JSON.parse(JSON.stringify(this.actions)) : []
        arr.forEach((a, i) => {
          if (!a) return
          // estado do collapsy: default fechado
          if (this.condOpen[i] == null) this.$set(this.condOpen, i, false)

          if (a.action === 'send_buttons' && !Array.isArray(a.buttons)) this.$set(a, 'buttons', [])
          if (a.action === 'send_list') {
            if (!Array.isArray(a.sections) || !a.sections.length) this.$set(a, 'sections', [{ title: 'Opções', rows: [] }])
            if (!Array.isArray(a.sections[0].rows)) this.$set(a.sections[0], 'rows', [])
            if (!a.button_text) this.$set(a, 'button_text', 'Ver opções')
          }
          if (a.conditional && a.action === 'send_text') {
            if (Array.isArray(a.conditional.days_of_week) && !a.conditional.days_of_weekProxy) {
              const proxy = {
                0: false, 1: false, 2: false, 3: false, 4: false, 5: false, 6: false,
              }
              for (const n of a.conditional.days_of_week) {
                if (typeof n === 'number' && n >= 0 && n <= 6) proxy[n] = true
              }
              this.$set(a.conditional, 'days_of_weekProxy', proxy)
            }
          }
          if (a.action === 'set_mode') {
            if (!a.mode) this.$set(a, 'mode', 'central')
            if (!Array.isArray(a.assign_random_agent_ids)) this.$set(a, 'assign_random_agent_ids', [])
            if (a.assign_agent_id != null) this.$delete(a, 'assign_agent_id')
          }
          if (a.action === 'set_tags') {
            if (!Array.isArray(a.tags)) this.$set(a, 'tags', [])
          }
          if (a.action === 'platform_lookup') {
            if (!a.op) this.$set(a, 'op', 'status_pedido')
            if (!a.messages || typeof a.messages !== 'object') this.$set(a, 'messages', {})
            this.ensurePlatformMessagesShape(a, /* silent= */true)
          }
        })
        this.local = arr
      } finally {
        this._hydrating = false
      }
    },
    emitChange() {
      if (this._hydrating) return
      this.$emit('update:actions', JSON.parse(JSON.stringify(this.local)))
      this.$emit('change')
    },

    /* ===== atendentes / tags ===== */
    maybeLoadAgents() { if (this.botUuid) this.loadAgents() },
    async loadAgents() {
      this.loadingAgents = true
      this.agentsError = null
      try {
        const resp = await buscaAtendentes(this.botUuid)
        const arr = (resp && (resp.atendentes || resp.data?.atendentes)) || []
        const norm = Array.isArray(arr) ? arr : []
        this.agentOptions = norm.map(a => {
          const id = (a.id != null ? a.id : (a.atendente_id != null ? a.atendente_id : a.value))
          const name = a.name || a.nome || a.display_name || `#${id}`
          return { value: String(id), text: name }
        })
      } catch (e) {
        this.agentsError = e?.message || 'Falha ao carregar atendentes'
        this.agentOptions = []
      } finally {
        this.loadingAgents = false
      }
    },
    maybeLoadTags() { if (this.botUuid) this.loadTags() },
    async loadTags() {
      this.loadingTags = true
      this.tagsError = null
      try {
        const resp = await buscaTag(this.botUuid)
        const list = Array.isArray(resp) ? resp : (resp?.data || resp?.tags || [])
        const norm = Array.isArray(list) ? list : []
        this.tagOptions = norm.map(t => ({
          value: String(t.id ?? t.value),
          text: t.nome || t.name || t.display_name || `Tag #${t.id ?? t.value}`,
          color: t.cor || null,
        }))
      } catch (e) {
        this.tagsError = e?.message || 'Falha ao carregar tags'
        this.tagOptions = []
      } finally {
        this.loadingTags = false
      }
    },

    /* ===== ações ===== */
    addAction() {
      this.local.push({ action: 'send_text', text: '' })
      // garante estado do collapse para o novo item
      this.$set(this.condOpen, this.local.length - 1, false)
      this.emitChange()
    },
    removeAction(i) {
      this.local.splice(i, 1)
      this.$delete(this.condOpen, i)
      this.emitChange()
    },
    onActionChange(i) {
      const a = this.local[i]
      if (!a) return

      const keep = keys => {
        Object.keys(a).forEach(k => {
          if (!keys.includes(k)) this.$delete(a, k)
        })
      }

      if (a.action === 'send_buttons') {
        if (!Array.isArray(a.buttons)) this.$set(a, 'buttons', [])
        keep(['action', 'header', 'body', 'footer', 'buttons', 'quickReplyTemplate'])
      } else if (a.action === 'send_list') {
        if (!Array.isArray(a.sections) || !a.sections.length) this.$set(a, 'sections', [{ title: 'Opções', rows: [] }])
        if (!Array.isArray(a.sections[0].rows)) this.$set(a.sections[0], 'rows', [])
        if (!a.button_text) this.$set(a, 'button_text', 'Ver opções')
        keep(['action', 'header', 'body', 'footer', 'button_text', 'sections'])
      } else if (a.action === 'ask_var') {
        if (typeof a.var !== 'string') this.$set(a, 'var', '')
        if (typeof a.prompt !== 'string') this.$set(a, 'prompt', '')
        keep(['action', 'var', 'prompt'])
      } else if (a.action === 'set_mode') {
        if (!a.mode) this.$set(a, 'mode', 'central')
        if (!Array.isArray(a.assign_random_agent_ids)) this.$set(a, 'assign_random_agent_ids', [])
        if (a.assign_agent_id != null) this.$delete(a, 'assign_agent_id')
        this.maybeLoadAgents()
        keep(['action', 'mode', 'assign_random_agent_ids'])
      } else if (a.action === 'set_tags') {
        if (!Array.isArray(a.tags)) this.$set(a, 'tags', [])
        this.maybeLoadTags()
        keep(['action', 'tags'])
      } else if (a.action === 'goto') {
        if (typeof a.state !== 'string') this.$set(a, 'state', '')
        keep(['action', 'state'])
      } else if (a.action === 'end') {
        keep(['action'])
      } else if (a.action === 'validate_customer') {
        keep(['action'])
      } else if (a.action === 'platform_lookup') {
        if (!a.op) this.$set(a, 'op', 'status_pedido')
        if (!a.messages || typeof a.messages !== 'object') this.$set(a, 'messages', {})
        this.ensurePlatformMessagesShape(a, /* silent= */true)
        keep(['action', 'op', 'messages'])
      } else if (a.action === 'send_text') {
        if (typeof a.text !== 'string') this.$set(a, 'text', '')
        keep(['action', 'text', 'conditional', 'preview'])
      }

      this.emitChange()
    },

    /* ===== regras (hidratação) ===== */
    buildRuleMap() {
      const map = {}
      const rules = Array.isArray(this.stateRules) ? this.stateRules : []
      for (let i = 0; i < rules.length; i++) {
        const r = rules[i] || {}
        const id = r && r.if && r.if.interactive_reply_id
        if (!id) continue
        const first = (Array.isArray(r.then) && r.then[0]) ? r.then[0] : null
        if (!first) { map[id] = { action: '' }; continue }
        if (first.action === 'goto') map[id] = { action: 'goto', state: first.state || '' }
        else if (first.action === 'set_mode' && first.mode === 'central') map[id] = { action: 'set_mode' }
        else if (first.action === 'end') map[id] = { action: 'end' }
        else map[id] = { action: '' }
      }
      return map
    },
    hydrateFromRules() {
      if (!Array.isArray(this.local) || !this.local.length) return
      const map = this.buildRuleMap()
      this._hydrating = true
      try {
        for (let i = 0; i < this.local.length; i++) {
          const a = this.local[i]; if (!a) continue
          if (a.action === 'send_buttons' && Array.isArray(a.buttons)) {
            for (let b = 0; b < a.buttons.length; b++) {
              const btn = a.buttons[b]; if (!btn) continue
              const m = map[btn.id]
              if (m) {
                if (btn.click_action !== m.action) this.$set(btn, 'click_action', m.action || '')
                if (m.action === 'goto' && btn.goto_state !== m.state) this.$set(btn, 'goto_state', m.state || '')
              } else if (btn.click_action == null) {
                this.$set(btn, 'click_action', '')
              }
            }
          }
          if (a.action === 'send_list' && Array.isArray(a.sections)) {
            for (let s = 0; s < a.sections.length; s++) {
              const sec = a.sections[s]; if (!sec || !Array.isArray(sec.rows)) continue
              for (let r = 0; r < sec.rows.length; r++) {
                const row = sec.rows[r]; if (!row) continue
                const mm = map[row.id]
                if (mm) {
                  if (row.click_action !== mm.action) this.$set(row, 'click_action', mm.action || '')
                  if (mm.action === 'goto' && row.goto_state !== mm.state) this.$set(row, 'goto_state', mm.state || '')
                } else if (row.click_action == null) {
                  this.$set(row, 'click_action', '')
                }
              }
            }
          }
          if (a.action === 'platform_lookup') {
            this.ensurePlatformMessagesShape(a, /* silent= */true)
          }
        }
      } finally {
        this._hydrating = false
      }
    },

    /* ===== send_text: helpers/toggles ===== */
    isFirstContactEnabled(a) { return !!(a && a.conditional && a.conditional.first_contact) },
    onToggleFirstContact(a, enabled) {
      if (!a) return
      if (enabled) {
        if (!a.conditional) this.$set(a, 'conditional', {})
        if (!a.conditional.first_contact) {
          const first = a.text || ''
          this.$set(a.conditional, 'first_contact', { first_time: first })
        }
      } else if (a.conditional && a.conditional.first_contact) {
        const first = a.conditional.first_contact.first_time
        if (typeof first === 'string' && first.length) a.text = first
        this.$delete(a.conditional, 'first_contact')
        this.cleanupEmptyConditional(a)
      }
      this.emitChange()
    },
    hasReturning(a) { return !!(a && a.conditional && a.conditional.first_contact && typeof a.conditional.first_contact.returning === 'string') },
    onToggleReturning(a, enabled) {
      if (!a || !a.conditional || !a.conditional.first_contact) return
      if (enabled) {
        if (typeof a.conditional.first_contact.returning !== 'string') {
          this.$set(a.conditional.first_contact, 'returning', '')
        }
      } else if (typeof a.conditional.first_contact.returning === 'string') {
        this.$delete(a.conditional.first_contact, 'returning')
      }
      this.emitChange()
    },
    isDaysEnabled(a) { return !!(a && a.conditional && Array.isArray(a.conditional.days_of_week)) },
    onToggleDays(a, enabled) {
      if (!a) return
      if (enabled) {
        if (!a.conditional) this.$set(a, 'conditional', {})
        if (!Array.isArray(a.conditional.days_of_week)) this.$set(a.conditional, 'days_of_week', [])
        if (!a.conditional.days_of_weekProxy) {
          const proxy = {
            0: false, 1: false, 2: false, 3: false, 4: false, 5: false, 6: false,
          }
          this.$set(a.conditional, 'days_of_weekProxy', proxy)
        }
      } else {
        if (a.conditional && a.conditional.days_of_weekProxy) this.$delete(a.conditional, 'days_of_weekProxy')
        if (a.conditional && Array.isArray(a.conditional.days_of_week)) this.$delete(a.conditional, 'days_of_week')
        this.cleanupEmptyConditional(a)
      }
      this.emitChange()
    },
    setDaysProxyVal(a, index, val) {
      if (!a || !a.conditional || !a.conditional.days_of_weekProxy) return
      this.$set(a.conditional.days_of_weekProxy, index, val)
      const proxy = a.conditional.days_of_weekProxy
      const arr = []
      for (const k in proxy) if (proxy[k]) arr.push(Number(k))
      this.$set(a.conditional, 'days_of_week', arr)
      this.emitChange()
    },
    isDatesEnabled(a) { return !!(a && a.conditional && Array.isArray(a.conditional.dates)) },
    onToggleDates(a, enabled) {
      if (!a) return
      if (enabled) {
        if (!a.conditional) this.$set(a, 'conditional', {})
        if (!Array.isArray(a.conditional.dates)) this.$set(a.conditional, 'dates', [])
      } else {
        if (a.conditional && Array.isArray(a.conditional.dates)) this.$delete(a.conditional, 'dates')
        this.cleanupEmptyConditional(a)
      }
      this.emitChange()
    },
    cleanupEmptyConditional(a) {
      if (!a.conditional) return
      const keys = Object.keys(a.conditional)
      if (!keys.length) this.$delete(a, 'conditional')
    },

    /* ===== Multi-select helpers ===== */
    selectedAgents(a) {
      const set = new Set((a.assign_random_agent_ids || []).map(String))
      return this.agentOptions.filter(o => set.has(String(o.value)))
    },
    removeSelectedAgent(a, id) {
      const cur = Array.isArray(a.assign_random_agent_ids) ? a.assign_random_agent_ids.map(String) : []
      const next = cur.filter(v => String(v) !== String(id))
      this.$set(a, 'assign_random_agent_ids', next)
      this.emitChange()
    },
    selectedTags(a) {
      const set = new Set((a.tags || []).map(String))
      return this.tagOptions.filter(o => set.has(String(o.value)))
    },
    removeSelectedTag(a, id) {
      const cur = Array.isArray(a.tags) ? a.tags.map(String) : []
      const next = cur.filter(v => String(v) !== String(id))
      this.$set(a, 'tags', next)
      this.emitChange()
    },

    /* ===== util ===== */
    slug(s) {
      if (!s) return ''
      return String(s)
        .toLowerCase()
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9\s_-]/g, '')
        .trim()
        .replace(/\s+/g, '_')
        .replace(/_+/g, '_')
    },

    /* ===== platform_lookup shape helpers ===== */
    ensurePlatformMessagesShape(a, silent = false) {
      if (!a || a.action !== 'platform_lookup') return
      const op = a.op || 'status_pedido'
      if (!a.messages || typeof a.messages !== 'object') this.$set(a, 'messages', {})

      if (op === 'status_pedido') {
        if (Array.isArray(a.messages.analise_de_pagamento) && !Array.isArray(a.messages.analise_pagamento)) {
          this.$set(a.messages, 'analise_pagamento', a.messages.analise_de_pagamento)
          this.$delete(a.messages, 'analise_de_pagamento')
        }

        const keys = ['aguardando_pagamento', 'aprovado', 'cancelado', 'analise_pagamento', 'em_transporte', 'entregue']
        keys.forEach(k => {
          if (!Array.isArray(a.messages[k]) || !a.messages[k].length || !a.messages[k][0]) {
            this.$set(a.messages, k, [{ action: 'send_text', text: '' }])
          } else {
            if (a.messages[k][0].action !== 'send_text') a.messages[k][0].action = 'send_text'
            if (typeof a.messages[k][0].text !== 'string') a.messages[k][0].text = ''
          }
        })
        if (Array.isArray(a.messages.found)) this.$delete(a.messages, 'found')
        if (Array.isArray(a.messages.not_found)) this.$delete(a.messages, 'not_found')
      } else {
        ['found', 'not_found'].forEach(k => {
          if (!Array.isArray(a.messages[k]) || !a.messages[k].length || !a.messages[k][0]) {
            this.$set(a.messages, k, [{ action: 'send_text', text: '' }])
          } else {
            if (a.messages[k][0].action !== 'send_text') a.messages[k][0].action = 'send_text'
            if (typeof a.messages[k][0].text !== 'string') a.messages[k][0].text = ''
          }
        });
        ['aguardando_pagamento', 'aprovado', 'cancelado', 'analise_pagamento', 'analise_de_pagamento', 'em_transporte', 'entregue']
          .forEach(k => { if (Array.isArray(a.messages[k])) this.$delete(a.messages, k) })
      }
      if (!silent) this.emitChange()
    },
    onPlatformOpChange(a) {
      this.ensurePlatformMessagesShape(a, /* silent= */true)
      this.emitChange()
    },

    /* ===== buttons/list helpers + auto-regras ===== */
    addButton(i) {
      const a = this.local[i]; if (!a) return
      if (!Array.isArray(a.buttons)) this.$set(a, 'buttons', [])
      a.buttons.push({
        title: '', id: '', click_action: '', goto_state: '',
      })
      this.emitChange()
    },
    removeButton(a, idx) {
      const removed = a.buttons[idx]
      a.buttons.splice(idx, 1)
      if (removed && removed.id) this.$emit('rule-remove', { id: removed.id, stateName: this.stateName })
      this.emitChange()
    },
    onButtonTitleChange(a, btn) {
      if (!btn) return
      // Limite de 20 chars (defensivo)
      const limited = String(btn.title || '').slice(0, 20)
      if (btn.title !== limited) this.$set(btn, 'title', limited)
      const oldId = String(btn.id || '')
      const newId = this.slug(limited)
      if (newId && newId !== oldId) {
        this.$set(btn, 'id', newId)
        if (oldId) this.$emit('rule-rename', { oldId, newId, stateName: this.stateName })
      } else if (!newId && !oldId) {
        this.$set(btn, 'id', '')
      }
      this.emitChange()
    },
    onButtonActionChanged(btn) {
      this.emitChange()
      if (!this.autoRules || !btn || !btn.id) return
      this.$emit('rule-for', {
        id: btn.id,
        click_action: btn.click_action || '',
        goto_state: btn.goto_state || '',
        stateName: this.stateName,
      })
    },
    emitRuleForButton(btn) {
      this.emitChange()
      if (!this.autoRules || !btn || !btn.id) return
      this.$emit('rule-for', {
        id: btn.id,
        click_action: btn.click_action || '',
        goto_state: btn.goto_state || '',
        stateName: this.stateName,
      })
    },

    addRow(i) {
      const a = this.local[i]; if (!a) return
      if (!Array.isArray(a.sections)) this.$set(a, 'sections', [{ title: 'Opções', rows: [] }])
      if (!Array.isArray(a.sections[0].rows)) this.$set(a.sections[0], 'rows', [])
      a.sections[0].rows.push({
        title: '', id: '', click_action: '', goto_state: '',
      })
      this.emitChange()
    },
    removeRow(a, idx) {
      const removed = a.sections[0].rows[idx]
      a.sections[0].rows.splice(idx, 1)
      if (removed && removed.id) this.$emit('rule-remove', { id: removed.id, stateName: this.stateName })
      this.emitChange()
    },
    onRowTitleChange(a, row) {
      if (!row) return
      // Limite de 24 chars (defensivo)
      const limited = String(row.title || '').slice(0, 24)
      if (row.title !== limited) this.$set(row, 'title', limited)
      const oldId = String(row.id || '')
      const newId = this.slug(limited)
      if (newId && newId !== oldId) {
        this.$set(row, 'id', newId)
        if (oldId) this.$emit('rule-rename', { oldId, newId, stateName: this.stateName })
      } else if (!newId && !oldId) {
        this.$set(row, 'id', '')
      }
      this.emitChange()
    },
    onRowActionChanged(row) {
      this.emitChange()
      if (!this.autoRules || !row || !row.id) return
      this.$emit('rule-for', {
        id: row.id,
        click_action: row.click_action || '',
        goto_state: row.goto_state || '',
        stateName: this.stateName,
      })
    },
    emitRuleForRow(row) {
      this.emitChange()
      if (!this.autoRules || !row || !row.id) return
      this.$emit('rule-for', {
        id: row.id,
        click_action: row.click_action || '',
        goto_state: row.goto_state || '',
        stateName: this.stateName,
      })
    },
  },
}
</script>

<style scoped>
.flip-list-move { transition: transform .2s; }
.font-weight-600 { font-weight: 600; }
.drag { cursor: grab; user-select: none; }

.action-card { border-radius: 12px; }
.section-title { font-weight: 600; color: #4b5563; }

/* checklist vertical */
.checklist { list-style: none; padding-left: 0; margin: 0; }
.checklist > li { padding: 6px 0; border-bottom: 1px dashed #eef2f7; }
.checklist > li:last-child { border-bottom: 0; }
.help { font-size: 12px; color: #6b7280; }

/* dias da semana */
.dow-wrap { display:flex; flex-wrap:wrap; gap:10px; }

/* campos empilhados (stacked) */
.stacked > * + * { margin-top: 10px; }

/* contador curto */
.char-hint { font-size: 11px; color:#6b7280; margin-top:4px; text-align:right; }

.toggle-collapse { border-radius: 8px; }

@media (max-width: 768px) {
  .action-card { padding: 2px; }
}
</style>
